export const NOVIDADE_DELETE = "NOVIDADE_DELETE";
export const NOVIDADE_UPDATE = "NOVIDADE_UPDATE";
export const NOVIDADE_CREATE = "NOVIDADE_CREATE";
export const NOVIDADE_LOAD = "NOVIDADE_LOAD";
export const COLOR = [
  {
    text: "Sem cor",
    value: "empty"
  },
  {
    text: "Vermelho",
    value: "red"
  },
  {
    text: "Laranja",
    value: "orange"
  },
  {
    text: "Amarelo",
    value: "yellow"
  },
  {
    text: "Verde Limão",
    value: "lime"
  },
  {
    text: "Verde",
    value: "green"
  },
  {
    text: "Turquesa",
    value: "teal"
  },
  {
    text: "Azul",
    value: "blue"
  },
  {
    text: "Roxo",
    value: "deep-purple"
  },
  {
    text: "Lilás",
    value: "purple"
  },
  {
    text: "Rosa",
    value: "pink"
  },
  {
    text: "Marrom",
    value: "brown"
  },
  {
    text: "Cinza",
    value: "grey"
  },
  {
    text: "Preto",
    value: "black"
  }
];
